import menuContainerHeight from "./menuContainerHeight";

export default function menuOpener() {
  var $wrapper = $('#wrapper');
  $('.overlay').click(function () {
    $('.menu-btn').removeClass('active');
    $('body').removeClass('menu-active');
    $wrapper.removeAttr('style');
  });

  $('.menu-btn').click(function () {
    if ($('.menu-btn').hasClass('active')) {
      $('.menu-btn').removeClass('active');
      $('body').removeClass('menu-active');
      $('.menu-container').removeClass("lvl-1 lvl-2 lvl-3 is-drop-active");
      $('.main-nav .dropdown').removeClass("is-open active-lvl");
      $wrapper.removeAttr('style');
    } else {
      $('.menu-btn').addClass('active');
      $('body').addClass('menu-active');

      menuContainerHeight();
    }
  });
}